module.exports = __webpack_public_path__ + "static/media/usuario.b5f9a514.png";